export class productHomeType {
  page_main_title: string;
  allProductHomes: any;
}

export class prismicLandingPage {
  brand: string;
  pageType: string;
  product: string;
  lang: string;
  isElectric: string;
  pageId: string;
  pageurl?: string;
  parenturl?: string;
}


export class prismicContent {
  content: any;
  pageMeta: any;
  pageClass?: any;
}
